// Fixed option sets for the Order Fulfilment board's dropdown fields.
export const CASE_GLASSES_PAIRED_OPTIONS = ['Linked', 'Unlinked'];
export const PRODUCT_TYPE_OPTIONS = ['Glasses', 'Case', 'Glasses and Case'];
export const GLASSES_VERSION_OPTIONS = ['Viaro', 'Itero'];
export const LENS_TYPE_OPTIONS = ['Transitions', 'Tinted', 'Any', 'No lenses', 'Custom'];

// The ticket "Labels" field used to be free-text; now a fixed dropdown.
export const LABEL_OPTIONS = ['New', 'Repair', 'Other'];
